import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { ConfirmationModalComponent } from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import { AuditTrailService } from 'src/app/shared/services/audit-trail.service';

@Component({
  selector: 'app-audit-configuration-header',
  templateUrl: './audit-configuration-header.component.html',
  styleUrls: ['./audit-configuration-header.component.less']
})
export class AuditConfigurationHeaderComponent implements OnInit {
  modalRef: BsModalRef;
  @Input() tableSettings;
  dateInputData: any = {};
  fromtimevalue: any;
  @Output() searchByName = new EventEmitter();
  @Output() resetFilters = new EventEmitter();
  @Output() exportExcel = new EventEmitter<object>();
  private unsubscribe$ =new Subject<void>();
  
  constructor(
    private auditService :AuditTrailService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.dateInputData.EndDate = new Date();
    this.fromtimevalue = this.GetTimeForDates(new Date);
    this.dateInputData.StartDate = new Date();
    this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate() - 7);
    this.dateInputData.maxDate = new Date();
    this.dateInputData.FromMinDate = new Date();
    this.dateInputData.FromMinDate.setDate(this.dateInputData.StartDate.getDate() - 1095);

    this.auditService.resetHeaders
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.dateInputData.StartDate = new Date();
      this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate()-7);
      this.dateInputData.EndDate = new Date();
      this.auditService.refreshPage.next();
    })
  }

  
  hideDropdowns() {
    this.tableSettings.forEach(item => {
      item.displaysort = false;
    })
  }
  SearchByUser(username,Fdate,Edate) {
    var fdate = Fdate.toISOString();
    var edate = Edate.toISOString();
    this.searchByName.emit({username,fdate, edate});
  }
  GetTimeForDates(date: Date): string {
    let time = moment(date).format("hh:mm A");
    return time;
  }
  ResetFilters() {
 /* this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Reset Filter';
    this.modalRef.content.description = 'Do you want to reset all filters';
    this.modalRef.content.buttonsTitle = {
      dismiss: 'Cancel',
      confirm: 'Reset',
      component: ComponentName.AuditConfiguration
    }*/
    window.location.reload();
  }
  ExportToExcel(username, fromdate, todate) {
    todate= new Date(todate);
    todate=todate.setDate(todate.getDate()+1);
    this.exportExcel.emit({ username: username,fromdate: new  Date(fromdate).toISOString(), todate: new  Date(todate).toISOString() });
  }
}
